module.exports = __webpack_public_path__ + "media/images/logos/University-of-Sydney-8d1772dc0f4be039d6b97a01ace298e5.svg";